import React, { useState } from 'react';
import { useMediaQuery, Toolbar, useTheme } from '@mui/material';
import { useHotkeys } from 'react-hotkeys-hook';
import SearchResults from '../../../SearchResults';
import SmallScreenItems from './SmallScreenItems';
import LargeScreenItems from './LargeScreenItems';
import { useLocation } from 'react-router-dom';

const primaryAppbarHeight = 60;

const PrimaryAppBar = () => {
  const { pathname } = useLocation();
  const [searchOpen, setSearchOpen] = useState(false);
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('md'));

  useHotkeys('meta+k', () => {
    setSearchOpen(true);
  });
  useHotkeys('esc', () => {
    setSearchOpen(false);
  });

  const logoLength = 30;

  if (pathname.match(/^\/onboarding/)) {
    return null;
  }

  return (
    <>
      <Toolbar
        sx={{
          height: primaryAppbarHeight,
          minHeight: primaryAppbarHeight,
          boxShadow: 'none',
          '@media print': {
            display: 'none',
          },
        }}
        color="primary"
      >
        {!smallScreen && (
          <LargeScreenItems
            setSearchOpen={setSearchOpen}
            logoLength={logoLength}
          />
        )}
        {smallScreen && <SmallScreenItems setSearchOpen={setSearchOpen} />}
      </Toolbar>
      <SearchResults open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
};

export default PrimaryAppBar;
